export enum PlatformConsoleRoutes {
  AccessCheck = 'access-check',
  BullBoard = 'bull-board',
  FeatureFlags = 'feature-flags',
}
